<template>
  <div class="section-container">

    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-globe mr-2" style="font-size: 20px !important;"></i>
            Interactions with Outside World
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-row v-if="interactions && interactions.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Description</th>
              <th>Academic Year</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="interaction in sortedInteractions" :key="interaction.id">
              <td>{{ interaction.si_no }}</td>
              <td>{{ interaction.description }}</td>
              <td>{{ interaction.academic_year }}</td>
              <td>
                <i class="fas fa-edit pointer text-info mr-2" style="font-size: 18px !important;"
                  @click="editInteraction(interaction)"></i>
                <i class="fas fa-trash fa-sm" style="cursor: pointer; color: #dc3545;"
                  @click="deleteInteraction(interaction)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Interactions with Outside World" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdateInteraction">
        <b-form-group label="SI No">
          <b-form-input v-model="interaction.si_no" type="number"></b-form-input>
        </b-form-group>
        <b-form-group label="Description">
          <b-form-input v-model="interaction.description"></b-form-input>
        </b-form-group>
        <b-form-group label="Academic Year">
          <b-form-input v-model="interaction.academic_year"></b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">
          {{ editIndex === null ? 'Save' : 'Update' }}
        </b-button>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      interaction: {
        si_no: "",
        description: "",
        academic_year: ""
      },
      interactions: this.profile.interactions || [],
    };
  },
  computed: {
    sortedInteractions() {
      return [...this.interactions].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    async createOrUpdateInteraction() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/interactions`;
        let response;

        if (this.editIndex === null) {
          // Create new
          response = await this.$axios.post(url, {
            si_no: Number(this.interaction.si_no),
            description: this.interaction.description,
            academic_year: this.interaction.academic_year,
            user_profile_id: this.profile.id,
          });
          this.interactions.unshift(response.data);
        } else {
          // Update existing
          const updateUrl = `${url}/${this.interaction.id}`;
          response = await this.$axios.put(updateUrl, {
            si_no: Number(this.interaction.si_no),
            description: this.interaction.description,
            academic_year: this.interaction.academic_year,
          });
          this.interactions.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating interaction:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },

    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.interactions = response.data.interactions;
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },

    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },

    editInteraction(interaction) {
      this.interaction = { ...interaction };
      this.editIndex = this.interactions.findIndex(i => i.id === interaction.id);
      this.showModal = true;
    },

    async deleteInteraction(interaction) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/interactions/${interaction.id}`;
        await this.$axios.delete(deleteUrl);
        const index = this.interactions.findIndex(i => i.id === interaction.id);
        if (index !== -1) {
          this.interactions.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("Interaction deleted", { position: "top", duration: 3000 });
      } catch (error) {
        console.error("Error deleting interaction:", error);
        this.$toast.error("Failed to delete interaction", { position: "top", duration: 3000 });
      }
    },

    resetForm() {
      this.interaction = {
        si_no: "",
        description: "",
        academic_year: ""
      };
      this.editIndex = null;
    }
  }
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
